import React, { useEffect, useRef, memo, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
const SubmenuItem = _ref => {
  let {
    activeItem,
    notificationCount,
    notificationRegularType,
    notificationPriorityType,
    title,
    updateActiveItemIndex,
    dataName,
    link,
    customBtnWrap
  } = _ref;
  const itemNode = useRef(null);
  useEffect(() => {
    activeItem && handleActiveItem(false);
  });
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const handleResize = () => {
    if (activeItem) {
      handleActiveItem(false);
    }
  };
  const handleActiveItem = changeIndex => {
    const node = itemNode.current;
    if (node) updateActiveItemIndex(node?.parentNode?.offsetLeft, node.offsetWidth, changeIndex);
  };
  const btnBody = useMemo(() => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "text"
    }, title), notificationCount && /*#__PURE__*/React.createElement("span", {
      className: classNames('wrts-notification-bubble', {
        inactive: !activeItem,
        regular: notificationRegularType,
        priority: notificationPriorityType
      })
    }, notificationCount));
  }, [title, activeItem, notificationCount]);
  return /*#__PURE__*/React.createElement("div", {
    className: "wrts-submenu-item",
    ref: itemNode
  }, link && customBtnWrap ? customBtnWrap({
    onClick: handleActiveItem,
    onTouchStart: handleActiveItem,
    className: classNames('wrts-submenu-link', {
      active: activeItem
    }),
    dataName,
    body: btnBody,
    link
  }) : /*#__PURE__*/React.createElement("button", {
    className: classNames('wrts-submenu-link', {
      active: activeItem
    }),
    onClick: handleActiveItem,
    onTouchStart: handleActiveItem,
    "data-name": dataName
  }, btnBody));
};
SubmenuItem.defaultProps = {
  dataName: '',
  customBtnWrap: () => {}
};
SubmenuItem.propTypes = {
  activeItem: PropTypes.bool.isRequired,
  notificationCount: PropTypes.number,
  notificationPriorityType: PropTypes.bool,
  title: PropTypes.string,
  updateActiveItemIndex: PropTypes.func.isRequired,
  dataName: PropTypes.string,
  customBtnWrap: PropTypes.func
};
export default /*#__PURE__*/memo(SubmenuItem);